import axios from 'axios';
import { getApiBaseUrl } from './apiBase';

const API_BASE_URL = getApiBaseUrl();
const API_URL = `${API_BASE_URL}/payments`;

export const paymentsService = {
  initialize: async ({ email, amount, shipmentId }, token) => {
    const callbackBase = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin : undefined;
    const response = await axios.post(`${API_URL}/initialize`, { email, amount, shipmentId, callbackBase }, {
      headers: { Authorization: `Bearer ${token}` },
      timeout: 20000,
      validateStatus: (status) => status >= 200 && status < 300
    });
    return response.data; // { success, data: { authorization_url, access_code, reference } }
  },

  verify: async (reference) => {
    const response = await axios.get(`${API_URL}/verify/${encodeURIComponent(reference)}`);
    return response.data; // { success, status, paidAmount, shipment, reference }
  },

  getStats: async (token) => {
    const response = await axios.get(`${API_URL}/stats`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  getTransactions: async (token) => {
    const response = await axios.get(`${API_URL}/transactions`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data; // { success, todayRevenue, transactions }
  }
};